import { Page401, Page498, useStoreUIV1 } from '@gimlite/ui-v1'
import { observer } from 'mobx-react-lite'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import MainUse from './main'
import { CollectsPage } from './pages/collects/view/collects.page'
import { SalesList } from './pages/sales/view/sales.search'

export const CustomRouter = observer(() => {
	const { SSOStore } = useStoreUIV1()

	const sitemap = [
		{
			path: '/',
			element: <MainUse />,
			children: [
				{
					index: true,
					element: <Navigate to={`/collects`} replace />
				},
				{
					path: '/collects',
					element: <CollectsPage />
				},
				{
					path: '/sales',
					element: <SalesList />
				}
			]
		}
	]

	return SSOStore?.error === 'UNAUTHORIZED' ? (
		<Page401 />
	) : SSOStore.authenticated && SSOStore.user ? (
		<RouterProvider router={createBrowserRouter(sitemap)}></RouterProvider>
	) : (
		<Page498 />
	)
})
